/**
 * @generated SignedSource<<e313630f55bc666c1ddf27353c69e9f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductStatus = "PUBLISHED" | "UN_PUBLISHED";
export type SetStatusProductInput = {
  productID: string;
  status: ProductStatus;
};
export type productSidePanelContent_SetStatusProductMutation$variables = {
  input: SetStatusProductInput;
};
export type productSidePanelContent_SetStatusProductMutation$data = {
  readonly setStatusProduct: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly model: {
      readonly id: string;
      readonly statusID: number;
    } | null;
  };
};
export type productSidePanelContent_SetStatusProductMutation = {
  response: productSidePanelContent_SetStatusProductMutation$data;
  variables: productSidePanelContent_SetStatusProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Model",
  "kind": "LinkedField",
  "name": "model",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "LiquidSintaxError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_SetStatusProductMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_SetStatusProductMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2dd63e376ef29c58c7f5128adfb36c6",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_SetStatusProductMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_SetStatusProductMutation(\n  $input: SetStatusProductInput!\n) {\n  setStatusProduct(input: $input) {\n    model {\n      id\n      statusID\n    }\n    errors {\n      __typename\n      ... on LiquidSintaxError {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ccf6ca91ef1212f2e7880b680c78a03";

export default node;
